import * as React from "react";
import ButtonPrintDialog from "src/content/applications/Print/ButtonPrintDialog";
import CommonDialog from "./CommonDialog";
import { ConfirmationDialog, ConfirmationOptions } from "./ConfirmationDialog";
import MesajDetay from "src/parts/Mesaj/Detay";
import { useAppSelector } from "src/store";
import HastaUyariEkrani from "src/content/applications/HastaUyari";
import HastaKaraListesiEkrani from "src/content/applications/HastaKaraListe";
import HastaKaraListeGenelUyari from "src/content/applications/HastaKaraListe/HastaKaraListeGenelUyari";
import HastaUyariPopup from "src/content/applications/HastaUyari/HastaUyariPopup";

const ConfirmationServiceContext = React.createContext<
  (options: ConfirmationOptions) => Promise<void>
>(Promise.reject);

export const useConfirmation = () =>
  React.useContext(ConfirmationServiceContext);

export const ConfirmationServiceProvider = ({ children }) => {
  const [
    confirmationState,
    setConfirmationState
  ] = React.useState<ConfirmationOptions | null>(null);

  const [open, setOpen] = React.useState<boolean>(false);

  const awaitingPromiseRef = React.useRef<{
    resolve: () => void;
    reject: () => void;
  }>();

  const openConfirmation = (options: ConfirmationOptions) => {
    setConfirmationState(options);
    setOpen(true);
    return new Promise<void>((resolve, reject) => {
      awaitingPromiseRef.current = { resolve, reject };
    });
  };

  const handleClose = () => {
    if (confirmationState.catchOnCancel && awaitingPromiseRef.current) {
      awaitingPromiseRef.current.reject();
    }
    setOpen(false);

  };

  const handleSubmit = () => {
    if (awaitingPromiseRef.current) {
      awaitingPromiseRef.current.resolve();
    }
    setOpen(false);
  };

  const handleClosed = () => {
    setConfirmationState(null);
  };

  const buttonPrintDialogOpen = useAppSelector(s => s.kararDestek.openDialog);
  const hastaUyariState = useAppSelector(s => s.hastaUyari);
  const hastaKaraListeState = useAppSelector(s => s.hastaKaraListe);

  return (
    <>
      <ConfirmationServiceContext.Provider
        value={openConfirmation}
        children={children}
      />

      <ConfirmationDialog
        open={open}
        onSubmit={handleSubmit}
        onClose={handleClose}
        onClosed={handleClosed}
        {...confirmationState}
      />
      <CommonDialog
        {...confirmationState}
      />
      {buttonPrintDialogOpen && <ButtonPrintDialog />}
      <MesajDetay />
      {hastaUyariState.open && <HastaUyariEkrani />}
      {hastaKaraListeState.open && <HastaKaraListesiEkrani />}
      <HastaKaraListeGenelUyari />
      <HastaUyariPopup />
    </>
  );
};
